<script setup lang="ts">
import { computed, type Component } from "vue";
import * as PhosphorIcons from "@phosphor-icons/vue";

const props = withDefaults(
  defineProps<{
    name: string;
    size?: number | string;
    weight?: "thin" | "light" | "regular" | "bold" | "fill" | "duotone";
  }>(),
  {
    size: 24,
    weight: "regular",
  }
);

// Convert kebab-case to PascalCase and prepend "Ph"
// e.g., "pencil-simple" → "PhPencilSimple"
function toPascalCase(str: string): string {
  return str
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join("");
}

const iconComponent = computed<Component | null>(() => {
  const pascalName = `Ph${toPascalCase(props.name)}`;
  const icon = (PhosphorIcons as Record<string, Component>)[pascalName];
  if (!icon) {
    console.warn(
      `PhosphorIcon: Icon "${props.name}" (${pascalName}) not found`
    );
    return null;
  }
  return icon;
});

const sizeStyle = computed(() => {
  const value = typeof props.size === "number" ? `${props.size}px` : props.size;
  return { width: value, height: value, flexShrink: 0 };
});
</script>

<template>
  <component
    v-if="iconComponent"
    :is="iconComponent"
    :size="size"
    :weight="weight"
    :style="sizeStyle"
  />
</template>
